<template>
    <div>
        <FieldValidationItem
            v-for="(validation, idx) in validations" :key="idx"
            :validation="validation"
            :field="field"
            @update="onValidationUpdate"
            @delete="onValidationDelete"
            class="mb-3 mt-2"/>

        <AppDropdown
            id="available-validations"
            :data="availableValidations"
            @select="onValidationAdd"
            :search="{ show: true, property: 'label', caseSensitive: false }">
            <template v-slot:menu-button>
                <div class="text-purple clickable" :class="{ 'mt-2': validations.length !== 0}">
                    Add
                </div>
            </template>
            <template #item="{ item }">
                {{ item.label }}
            </template>
        </AppDropdown>
    </div>
</template>

<script>
import FieldValidationItem from './FieldValidationItem'
import {
    FieldValidationLevels,
    FieldValidations,
    getFieldValidationInfo
} from '@/types/document-viewer/field/modules/validation'
import {FieldEditorTypes} from '@/types/document-viewer/field/modules/editor'
import {getDefaultFieldRuleParams} from '@/types/document-viewer/field/modules/rules'
import {cloneDeep, isArray} from 'lodash'

export default {
    name: 'FieldValidations',
    components: {FieldValidationItem},
    props: {
        field: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            availableValidations: []
        }
    },
    computed: {
        validations() {
            return isArray(this.field.validations) ? this.field.validations : []
        },

        editor() {
            return this.field.editor || {}
        }
    },
    methods: {
        onValidationUpdate(validation) {
            const validations = cloneDeep(this.validations)
            const idx = validations.findIndex(v => v.key === validation.key)
            if (idx !== -1) {
                validations[idx] = validation
            }
            this.$emit('update', validations)
        },

        onValidationDelete(validation) {
            const validations = cloneDeep(this.validations)
            const idx = validations.findIndex(v => v.key === validation.key)
            if (idx !== -1) {
                validations.splice(idx, 1)
            }
            this.$emit('update', validations)
        },

        onValidationAdd(validation) {
            const validations = cloneDeep(this.validations)
            validation.level = FieldValidationLevels.INFO
            validation.params = {}
            if (validation.key === FieldValidations.MIN_LENGTH) {
                validation.params.value = 1
            } else if (validation.key === FieldValidations.MAX_LENGTH) {
                validation.params.value = 100
            } else if (validation.key === FieldValidations.DATE) {
                validation.params.format = 'YYYY-MM-DD'
            } else if (validation.key === FieldValidations.REQUIRED_IF) {
                validation.params = getDefaultFieldRuleParams()
            }
            validations.push(validation)
            this.$emit('update', validations)
        }
    },
    watch: {
        validations: {
            handler(v) {
                const options = [{
                    key: FieldValidations.REQUIRED
                }, {
                    key: FieldValidations.REQUIRED_IF
                }]
                if (this.editor.type === FieldEditorTypes.NUMERIC) {
                    options.push({
                        key: FieldValidations.NUMBER
                    }, {
                        key: FieldValidations.ROUNDING,
                        params: {
                            value: 4
                        }
                    })
                } else if (this.editor.type === FieldEditorTypes.DATE) {
                    options.push({
                        key: FieldValidations.DATE
                    })
                } else if (this.editor.type === FieldEditorTypes.TEXT) {
                    options.push({
                        key: FieldValidations.MIN_LENGTH
                    }, {
                        key: FieldValidations.MAX_LENGTH
                    })
                }

                this.availableValidations = options
                    .filter(o => !this.validations.some(v => v.key === o.key))
                    .map(o => ({...o, ...getFieldValidationInfo({key: o.key, params: o.params})}))
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
